import {
  Beer, Camera, ChefHat, Clapperboard, Coffee, Crown, Globe, Hotel, MapPin, Megaphone,
  Package, PartyPopper, Rocket, Search, Share2, Shirt, Sofa, Target, TrendingUp, UtensilsCrossed,
} from "lucide-react";

export const SERVICE_ICONS = {
  TrendingUp, Share2, Search, Target, MapPin, Globe, Camera, Clapperboard,
  PartyPopper, Shirt, Sofa, Megaphone, Rocket, Crown, Package,
};

export const INDUSTRY_ICONS = { UtensilsCrossed, Coffee, Hotel, Beer, ChefHat, PartyPopper };
